import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/Api";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Loader2 } from "lucide-react";

export default function AuthScreen() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false); // State untuk loading
    const navigate = useNavigate();

    function authenticate(email, password) {
        setIsLoading(true); // Mulai loading
        api.post("/login", { email, password })
            .then(res => {
                localStorage.setItem("token", res.data.data);
                navigate("/transaction"); // Navigasi ke halaman transactions setelah login berhasil
            })
            .catch(e => {
                setError(e.response?.data?.metadata?.message || "Invalid Email or Password. Please try again.");
            })
            .finally(() => {
                setIsLoading(false); // Selesai loading
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email && password) {
            authenticate(email, password);
        } else {
            setError("Email and Password are required.");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-black p-4">
            <Card className="w-full max-w-md bg-zinc-950 border-zinc-800 text-white shadow-2xl">
                <CardHeader className="space-y-1">
                    <CardTitle className="text-3xl font-bold text-center tracking-tight text-red-600">
                        Millipoint
                    </CardTitle>
                    <CardDescription className="text-zinc-400 text-center text-sm">
                        Login Admin Panel
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email" className="text-zinc-300">Email Address</Label>
                            <Input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError(""); // Reset error saat user mulai mengetik
                                }}
                                className="bg-zinc-900 border-zinc-800 text-white placeholder-zinc-500 focus-visible:ring-red-600"
                                placeholder="admin@millipoint.id"
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password" className="text-zinc-300">Password</Label>
                            <Input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setError(""); // Reset error saat user mulai mengetik
                                }}
                                className="bg-zinc-900 border-zinc-800 text-white placeholder-zinc-500 focus-visible:ring-red-600"
                                placeholder="••••••••"
                                required
                            />
                        </div>
                        {error && (
                            <div className="text-sm text-red-500 font-medium">
                                {error}
                            </div>
                        )}
                        <Button
                            type="submit"
                            variant="secondary"
                            className="w-full font-semibold transition-colors"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                    Logging in...
                                </>
                            ) : (
                                "Login"
                            )}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}